<template>
	<div class="setting">
		<el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane label="个人信息" second name="first">
				<div class="container">
					<div class="title">头像设置</div>
					<div class="flex">
						<div class="flex_left">
							<div class="option">
								<span class="txt">头像</span>
								<div class="content">
									<div>上传头像</div>
									<div class="points">建议上传图片尺寸为60px*60px,如不设置则使用默认头像</div>
									<div class="update">
										<el-upload
											class="upload-demo"
											:action="defaultsUrl"
											:on-success="uploadHeadimg"
											:on-error="uploadHeadimgErr"
											multiple
											:limit="3"
											:show-file-list="false"
										>
											<el-button size="small" type="primary">点击上传</el-button>
											<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
										</el-upload>
									</div>
									<div class="save">
										<el-button type="primary" :disabled="uploadimg.shortHref==''" @click="updHeadimg">保存图片</el-button>
									</div>
								</div>
							</div>
						</div>
						<div class="flex_right">
							<div class="preview">预览</div>
							<div class="img_box">
								<img :src="uploadimg.href" style="width:100%;height:100%;" />
							</div>
						</div>
					</div>
					<div class="title">个人信息</div>
					<div class="flex">
						<div class="flex_left">
							<div class="option">
								<span class="txt">账号</span>
								<div class="content">
									<div class>{{userInfo.account}}</div>
								</div>
							</div>
							<div class="option">
								<span class="txt">姓名</span>
								<div class="content">
									{{userInfo.realName}}
									<!-- <el-input v-model="userInfo.realName" placeholder="请输入姓名"></el-input> -->
								</div>
							</div>
							<div class="option">
								<span class="txt">昵称</span>
								<div class="content">
									{{userInfo.nickName}}
									<!-- <el-input v-model="userInfo.nickName" placeholder="请输入昵称"></el-input> -->
								</div>
							</div>
							<div class="option">
								<span class="txt">手机</span>
								<div class="content">
									{{userInfo.mobile}}
									<!-- <el-input v-model="userInfo.mobile" placeholder="请输入手机"></el-input> -->
								</div>
							</div>
							<div class="option">
								<span class="txt">&nbsp;</span>
								<div class="content">
									<div class="save" style="margin-top:0;">
										<!-- <el-button type="primary" @click="updLoginMessage">保存</el-button> -->
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="title">密码设置</div>
					<div class="flex">
						<div class="flex_left" id="toPass">
							<el-form
								:model="passRuleForm"
								status-icon
								:rules="passRules"
								ref="passRuleForm"
								label-width="100px"
								class="demo-ruleForm"
								
							>
								<el-form-item label="原始密码" prop="originalPassword">
									<el-input type="password" v-model="passRuleForm.originalPassword"></el-input>
								</el-form-item>
								<el-form-item label="密码" prop="newsPassword">
									<el-input type="password" v-model="passRuleForm.newsPassword" autocomplete="off"></el-input>
								</el-form-item>
								<el-form-item label="确认密码" prop="checkPass">
									<el-input type="password" v-model="passRuleForm.checkPass" autocomplete="off"></el-input>
								</el-form-item>

								<el-form-item>
									<el-button type="primary" @click="submitPassForm('passRuleForm')">保存</el-button>
									<el-button @click="resePasstForm('passRuleForm')">重置</el-button>
								</el-form-item>
							</el-form>
						</div>
					</div>
				</div>
			</el-tab-pane>
			<el-tab-pane label="在线服务设置" name="first1">
				<div class="container">
					<div class="title">会话列表设置</div>
					<div class="flex">
						<div class="flex">
							<div class="flex_left">
								<div class="content">
									<div>会话列表排序</div>
									<div class="radio">
										<el-radio
											v-model="radio"
											:label="item.id"
											:key="index"
											v-for="(item,index) in orderConfig.filter(d=>d.groupId==1)"
											@change="updOrder(item)"
										>{{item.name}}</el-radio>
									</div>
									<div>访客等待回复计时提醒</div>
									<div class="switch">
										<el-switch
											v-model="switchvalue"
											active-text="开启"
											inactive-text="关闭"
											@change="onChangeAwait"
										></el-switch>
									</div>
									<div>开启自动接入</div>
									<div class="switch">
										<el-switch
											v-model="automaticAccess"
											active-text="开启"
											inactive-text="关闭"
											@change="onChangeAutoAccess"
										></el-switch>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</el-tab-pane>
			<el-tab-pane label="快捷服务" name="third">
				<div class="service">
					<div class="tac">
						<el-col :span="24" class="warpper">
							<el-tree
								@node-click="NodeClisk"
								:data="quickTree"
								:default-expanded-keys="[0]"
								ref="tree"
								node-key="id"
								:expand-on-click-node="false"
								:render-content="renderContent"
								v-loading="fetchLoding"
								:highlight-current="true"
							></el-tree>
						</el-col>
					</div>
					<div class="tabs">
						<div class="tab-option" v-if="show==1">
							<div class="content-box">
								<div class="title">个人库组</div>
								<el-button-group class="delete">
									<el-button type="primary" @click="addProblem">添加问题</el-button>
									<el-tooltip class="item" effect="dark" content="请先选择类别导入" placement="top-start">
										<el-button
											type="primary"
											:loading="importLoading"
											@click="importQuick"
										>{{importLoading?'正在处理...':'导入'}}</el-button>
									</el-tooltip>
									<el-tooltip class="item" effect="dark" content="根据搜索内容进行导出" placement="top-start">
										<el-button
											type="primary"
											@click="exportTable"
											:loading="exportButtonLoading"
										>{{exportButtonLoading?'正在处理...':'导出'}}</el-button>
									</el-tooltip>
									<el-tooltip class="item" effect="dark" content="删除已勾选">
										<el-button type="danger" icon="el-icon-delete" @click="deleteQuicks"></el-button>
									</el-tooltip>
									<el-tooltip class="item" effect="dark" content="下载导入模板">
										<el-button icon="el-icon-download" @click="downloadTemplate"></el-button>
									</el-tooltip>
								</el-button-group>
								<el-input placeholder="搜索快捷回复" v-model="quickRequest.keyWord">
									<el-button slot="append" icon="el-icon-search" @click="fetchQueryList"></el-button>
								</el-input>
								<div class="clear"></div>

								<el-upload
									class="upload-demo"
									:action="importDefaultsUrl"
									:on-success="uploadExcel"
									:on-error="uploadExcelErr"
									:before-upload="uploadExcelChange"
									:data="importData"
									multiple
									ref="uploadShow"
									:limit="3"
									:show-file-list="false"
									v-show="false"
								></el-upload>
							</div>
							<div class="table_box">
								<el-table
									ref="multipleTable"
									:data="quickPageList.list"
									tooltip-effect="dark"
									style="width: 100%;"
									border
									stripe
									@select-all="select_all"
									@select="select"
									v-loading="quickListLoading"
								>
									<el-table-column type="selection" width="55"></el-table-column>
									<el-table-column prop="keyWord" label="快捷词" width="120"></el-table-column>
									<el-table-column prop="content" label="回复内容" show-overflow-tooltip></el-table-column>
									<el-table-column prop="useCount" label="使用次数" width="200" sortable></el-table-column>
									<el-table-column prop="operate" label="操作" width="120">
										<template slot-scope="scope">
											<i class="el-icon-edit" @click="editQuick(scope.row)"></i>
											<i class="el-icon-delete" @click="deleteQuick(scope.row.id)"></i>
										</template>
									</el-table-column>
								</el-table>
							</div>
							<div class="pagination">
								<el-pagination
									:page-size="quickPageList.pagination.pageSize"
									background
									layout="total, prev, pager, next"
									:total="quickPageList.pagination.total"
									@current-change="quickChange"
								></el-pagination>
							</div>
							<el-dialog
								:title="quickReply.id>0?'修改快捷回复':'添加快捷回复'"
								:visible.sync="problemVisible"
								width="30%"
								:before-close="handleClose"
							>
								<div class="dialog">
									<el-form
										:model="quickReply"
										:rules="quickReplyRules"
										ref="quickReply"
										label-width="100px"
										class="demo-ruleForm"
									>
										<el-form-item label="类别" prop="groupId">
											<el-select v-model="quickReply.groupId" disabled placeholder="问题类别">
												<el-option
													v-for="item in groupList"
													:key="item.id"
													:label="item.groupName"
													:value="item.id"
												></el-option>
											</el-select>
										</el-form-item>
										<el-form-item label="快捷词" prop="keyWord">
											<el-input placeholder="请输入内容" v-model="quickReply.keyWord" class="input">
												<template slot="prepend">#</template>
											</el-input>
										</el-form-item>
										<el-form-item label="回复内容" prop="content">
											<el-input
												type="textarea"
												class="input textarea"
												placeholder="请输入内容"
												resize="none"
												v-model="quickReply.content"
												maxlength="150"
												show-word-limit
											></el-input>
											<i
												class="iconfont icon-biaoqing emoji_box"
												@click="show4=!show4"
												style="font-size: 24px;"
											></i>
											<div id="emoji1" v-if="show4">
												<div
													class="el-tabs__content"
													style="display: inline-block;"
													v-for="(emojiCon, emojiKey, eInd) in emojiIcon"
													v-if="eInd == eindex"
													:key="emojiKey"
													:label="emojiKey"
													:name="emojiKey"
												>
													<span
														@click="choose(emoItem)"
														:key="emoInd"
														v-for="(emoItem, emoInd) in emojiCon"
														v-html="emoItem.emoji"
													></span>
												</div>
											</div>
										</el-form-item>
									</el-form>
								</div>
								<span slot="footer" class="dialog-footer">
									<el-button @click="resetQuery('quickReply')">取 消</el-button>
									<el-button type="primary" @click="addQuery('quickReply')">{{quickReply.id>0?'修改':'添加'}}</el-button>
								</span>
							</el-dialog>
						</div>
						<div class="tab-option" v-if="show==2">2</div>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
		<el-dialog title="添加分组" :visible.sync="addGroupVisible" width="30%">
			<div class="dialog">
				<div class="section">
					<span class="label">类别</span>
					<div class="input_box">
						<el-input placeholder="输入类别" v-model="quickGroup" />
					</div>
					<div class="clear"></div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="addGroupVisible = false">取 消</el-button>
				<el-button type="primary" @click="AddQuickGroup">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
let emojiData = require('@/assets/emoji/emoji.json')
import { DateTime } from '@/utils/common'
import { isPasswd } from '@/utils/checkHelper.js'
import { getUserConfigs } from '@/utils/getUserConfig'
import CryptoJS from 'crypto-js';
export default {
	name: 'setting',
	props: [],
	data() {
		var validatePass = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入密码'))
			} else {
				if (this.passRuleForm.checkPass !== '') {
					this.$refs.passRuleForm.validateField('checkPass')
				}
				if (isPasswd(value) == false) {
					callback(
						new Error(
							'密码格式错误、必须包含大小写字母数字和特殊符号、长度6-12位'
						)
					)
				}
				callback()
			}
		}
		var validatePass2 = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入密码'))
			} else if (value !== this.passRuleForm.newsPassword) {
				callback(new Error('两次输入密码不一致!'))
			} else {
				callback()
			}
		}
		return {
			emojiIcon: emojiData.icon,
			eindex: 0,
			text: '',
			dialogVisible: false,
			show: 1,
			switchvalue: false,
			automaticAccess: false,
			radio: 1,
			activeName: 'first',
			orderConfig: [],
			addGroupVisible: false,
			groupList: [],
			quickGroup: '',
			problemVisible: false,
			quickReply: {
				groupId: undefined,
				keyWord: '',
				content: '',
				id: 0
			},
			show4: false,
			quickReplyRules: {
				groupId: [
					{
						required: true,
						message: '请选择分组类别',
						trigger: 'change'
					}
				],
				keyWord: [
					{
						required: true,
						message: '请输入关键字',
						trigger: 'blur'
					}
				],
				content: [
					{
						required: true,
						message: '请输入回复内容',
						trigger: 'blur'
					}
				]
			},
			quickRequest: {
				keyWord: '',
				groupId: 0,
				pagination: {
					pageIndex: 1,
					pageSize: 10,
					total: 10
				}
			},
			quickPageList: {
				list: [],
				pagination: {
					pageIndex: 1,
					pageSize: 10,
					total: 10
				}
			},
			quickListLoading: false,
			selectedRow: [],
			defaultsUrl: '',
			uploadimg: {
				href: '../../../assets/preview.png',
				shortHref: ''
			},
			userInfo: {
				account: '',
				realName: '',
				nickname: '',
				mobile: ''
			},
			passRuleForm: {
				newsPassword: '',
				checkPass: '',
				originalPassword: ''
			},
			passRules: {
				newsPassword: [{ validator: validatePass, trigger: 'blur' }],
				checkPass: [{ validator: validatePass2, trigger: 'blur' }],
				originalPassword: [
					{
						required: true,
						message: '请输入原始密码',
						trigger: 'blur'
					}
				]
			},
			exportButtonLoading: false,
			importDefaultsUrl: '',
			importData: {},
			importLoading: false,
			quickTree: [],
			addQuickGroups: '',
			treeData: {},
			groupId: 0,
			defaultLabel: ''
		}
	},
	watch: {},
	created: function() {
		this.getListOrder()
		this.getQuickGroup()
		this.fetchQueryList()
		// this.defaultsUrl = this.axios.defaults.baseURL + 'Upload/upload?files=1'
		this.defaultsUrl = this.axios.defaults.baseURL + 'Upload/uploadheadimgs'
		this.importDefaultsUrl =
			this.axios.defaults.baseURL + 'QuickReply/ImportQuick'
		this.getUserInfo()
		let loginModel = JSON.parse(localStorage.getItem(this.LoginInfo))
		this.uploadimg.href = loginModel.headimg
		let msg = this.$route.query.key
		if (msg == 'updPass') {
			setTimeout(function() {
				var ele = document.getElementsByClassName('container')
				ele[0].scrollTop = ele[0].scrollHeight
			}, 50)
		} else if (msg == 'addQuick') {
			this.activeName = 'third'
		}
		this.getQuickGroups(1)
		let $this = this
			var type = this.$route.query.type;
		if(type==1){
			setTimeout(() => {
				if (document.getElementById('toPass')) {
					let container = document.getElementById('toPass').offsetTop;
					debugger
					 $this.$nextTick(()=>{
						 //debugger
						 document.getElementById('toPass').scrollIntoView()  //滚动到指定位置
						 //$this.$refs.passRuleForm.scrollTo=co·ntainer;
					 })		 
				}
			}, 500);
			// let container = document.getElementById('toPass');

    		//  let x = this.$refs.passRuleForm.scrollTo(0, container, true);
		     
		}
	},
	methods: {
		getListOrder() {
			let vm = this
			this.axios.get('Dialogue/gDOE').then(function({ data }) {
				vm.orderConfig = data
				vm.radio = data.find(d => d.selected == 1 && d.groupId == 1).id

				vm.switchvalue =
					data.find(d => d.selected == 1 && d.groupId == 2) !=
					undefined
				vm.automaticAccess =
					data.find(d => d.selected == 1 && d.groupId == 3) !=
					undefined
			})
		},
		handleClick(tab, event) {},
		choose(data) {
			// console.log(key)
			// this.show = key
			this.quickReply.content += data.emoji
			this.show4 = false
		},
		select_all(row) {
			//全选
			this.selectedRow = row
		},
		select(row) {
			//选中某行
			this.selectedRow = row
		},
		/*提示框*/
		handleClose(done) {
			this.$confirm('确认关闭？')
				.then(_ => {
					done()
				})
				.catch(_ => {})
		},
		onChangeAwait(val) {
			var obj = new Object()
			obj.dialogOrder_Id = 4
			obj.dialogOrder_GroupId = 2
			obj.isOpen = val
			let vm = this
			this.axios
				.post('Dialogue/UpdOrderConfig', obj)
				.then(function({ data }) {
					if (data.result != true) {
						vm.$message({ type: 'error', message: data.message })
					} else {
						localStorage.removeItem('USER_CONFIG')
						getUserConfigs()
					}
				})
		},
		onChangeAutoAccess(val) {
			var obj = new Object()
			obj.dialogOrder_Id = 5
			obj.dialogOrder_GroupId = 3
			obj.isOpen = val
			let vm = this
			this.axios
				.post('Dialogue/UpdOrderConfig', obj)
				.then(function({ data }) {
					if (data.result != true) {
						vm.$message({ type: 'error', message: data.message })
					} else {
						localStorage.removeItem('USER_CONFIG')
						getUserConfigs()
					}
				})
		},
		updOrder(val) {
			var obj = new Object()
			obj.dialogOrder_Id = val.id
			obj.dialogOrder_GroupId = val.groupId
			obj.isOpen = true
			let vm = this
			this.axios
				.post('Dialogue/UpdOrderConfig', obj)
				.then(function({ data }) {
					if (data.result != true) {
						vm.$message({ type: 'error', message: data.message })
					} else {
						localStorage.removeItem('USER_CONFIG')
						getUserConfigs()
					}
				})
		},
		getQuickGroup() {
			let vm = this
			this.axios
				.get('QuickReply/GetQuickByVM', {
					params: { isUser: true }
				})
				.then(function({ data }) {
					if (data.result) {
						vm.groupList = data.data
					}
				})
		},
		AddQuickGroup(data) {
			let vm = this
			let date = new DateTime()
			this.axios
				.post('QuickReply/AddGroupQuick', {
					type: 1,
					Name: vm.quickGroup,
					Parentid: vm.treeData.id,
					CreateTime: date.Now()
				})
				.then(function(result) {
					if (!result.data.code) {
						vm.$notify.error({
							title: '错误',
							message: data.message
						})
					} else {
						vm.groupId = result.data.id
						const newChild = {
							id: result.data.id,
							label: 'add',
							children: []
						}
						if (!data.children) {
							vm.$set(data, 'children', [])
						}
						data.children.push(newChild)
					}
					vm.addGroupVisible = false
				})
		},
		QuickGroupSelected(val) {
			this.quickRequest.groupId = val.id
			this.fetchQueryList()

			this.importDefaultsUrl =
				this.axios.defaults.baseURL +
				'QuickReply/ImportQuick' +
				'?groupId=' +
				val.id
		},
		addQuery(formName) {
			let vm = this
			if (vm.quickReply.keyWord.indexOf('#') == -1) {
				vm.quickReply.keyWord = '#' + vm.quickReply.keyWord
			}
			this.$refs[formName].validate(valid => {
				if (valid) {
					if (vm.quickReply.id > 0) {
						vm.edit()
					} else {
						vm.add()
					}
				} else {
					console.log('error submit!!')
					return false
				}
			})
		},
		add() {
			let vm = this
			this.axios
				.post('QuickReply/AddQuick', vm.quickReply)
				.then(function({ data }) {
					if (data.code == 200) {
						vm.fetchQueryList()
						vm.problemVisible = false
						vm.resetQuery('quickReply')
						vm.$message({
							message: '添加成功',
							type: 'success'
						})
					}
				})
		},
		edit() {
			let vm = this
			this.axios
				.post('QuickReply/edit', vm.quickReply)
				.then(function({ data }) {
					if (data.result) {
						vm.fetchQueryList()
						vm.problemVisible = false
						vm.resetQuery('quickReply')
						vm.$message({
							message: '修改成功',
							type: 'success'
						})
					}
				})
		},
		deleteQuick(id) {
			let vm = this
			this.$confirm('此项永久删除, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					this.axios
						.get('QuickReply/delete', { params: { id: id } })
						.then(function({ data }) {
							if (data.result) {
								vm.$message({
									message: '删除成功',
									type: 'success'
								})
								vm.fetchQueryList()
							}
						})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					})
				})
		},
		deletesQuick(id) {},
		resetQuery(formName) {
			this.$refs[formName].resetFields()
			this.problemVisible = false
		},
		fetchQueryList() {
			let vm = this
			vm.quickListLoading = true
			this.axios
				.post('QuickReply/quickList', vm.quickRequest)
				.then(function({ data }) {
					if (data.result) {
						vm.quickPageList = data.data
						vm.quickRequest.pagination = data.data.pagination
					}
					vm.quickListLoading = false
				})
		},
		quickChange(sr) {
			let vm = this
			vm.quickRequest.pagination.pageIndex = sr
			vm.fetchQueryList()
		},
		editQuick(item) {
			let vm = this
			vm.quickReply.groupId = item.groupId
			vm.quickReply.keyWord = item.keyWord
			vm.quickReply.content = item.content
			vm.quickReply.id = item.id
			vm.problemVisible = true
		},
		deleteQuicks() {
			let vm = this
			if (vm.selectedRow && vm.selectedRow.length > 0) {
				let array = vm.selectedRow.map(d => d.id)
				this.$confirm('此项永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						this.axios
							.post('QuickReply/deletes', array)
							.then(function({ data }) {
								if (data.result) {
									vm.$message({
										message: '删除成功',
										type: 'success'
									})
									vm.fetchQueryList()
								}
							})
					})
					.catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						})
					})
			} else {
				this.$confirm('至少选中一行', '提示', {
					confirmButtonText: '确定',
					type: 'warning'
				})
			}
		},
		uploadHeadimg(response, file, fileList) {
			if (response.result) {
				this.uploadimg = response
			}
		},
		uploadHeadimgErr(err, file, fileList) {
			console.log(err)
		},
		getUserInfo() {
			let vm = this
			this.axios.get('User/Login_information').then(function({ data }) {
				vm.uploadimg.href = data.headImg
				vm.userInfo = data
			})
		},
		updLoginMessage() {
			let vm = this
			if (
				vm.userInfo.realName == undefined ||
				vm.userInfo.realName == ''
			) {
				vm.$message({ type: 'error', message: '姓名不能为空' })
				return
			}
			if (
				vm.userInfo.nickName == undefined ||
				vm.userInfo.nickName == ''
			) {
				vm.$message({ type: 'error', message: '昵称不能为空' })
				return
			}
			if (vm.userInfo.mobile == undefined || vm.userInfo.mobile == '') {
				vm.$message({ type: 'error', message: '手机号不能为空' })
				return
			}
			this.axios
				.post(
					'User/Update_LoginMessage?RealName=' +
						vm.userInfo.realName +
						'&NickName=' +
						vm.userInfo.nickName +
						'&Mobile=' +
						vm.userInfo.mobile
				)
				.then(function({ data }) {
					if (data.code == 200) {
						vm.$message({ type: 'success', message: '修改成功' })
					} else {
						vm.$message({ type: 'error', message: data.message })
					}
				})
		},
		updHeadimg() {
			let vm = this
			this.axios
				.get('User/upd_headImg', {
					params: { path: vm.uploadimg.shortHref }
				})
				.then(function({ data }) {
					if (data.result) {
						vm.$message({ type: 'success', message: '修改成功' })
						vm.$emit('updUserHeadimg', vm.uploadimg.href)
					} else {
						vm.$message({ type: 'error', message: data.message })
					}
				})
		},
		submitPassForm(formName) {
			let vm = this
			this.$refs[formName].validate(valid => {
				if (valid) {
					debugger
					var obj = new Object();
				obj.newsPassword = vm.encryptECB(vm.passRuleForm.newsPassword);
				obj.checkPass = vm.encryptECB(vm.passRuleForm.checkPass);
				obj.originalPassword = vm.encryptECB(vm.passRuleForm.originalPassword);
					this.axios
						.post('User/upd_pass',obj)
						.then(function({ data }) {
							if (data.result) {
								vm.$message({
									type: 'success',
									message: data.message
								})
								vm.resePasstForm('passRuleForm')
							} else {
								vm.$message({
									type: 'error',
									message: data.message
								})
							}
						})
				} else {
					console.log('error submit!!')
					return false
				}
			})
		},
		resePasstForm(formName) {
			this.$refs[formName].resetFields()
		},
		exportTable() {
			let vm = this
			vm.exportButtonLoading = true
			this.axios
				.post('QuickReply/exportQuickReply', vm.quickRequest, {
					responseType: 'blob' //设置响应的数据类型为一个包含二进制数据的 Blob 对象，必须设置！！！
				})
				.then(function(res) {
					vm.exportButtonLoading = false
					let filename = '快捷回复.xls'
					let blob = res.data
					let reader = new FileReader()
					reader.readAsDataURL(blob)
					reader.onload = e => {
						//创建a标签，插入到文档中并click，最后移除
						let a = document.createElement('a')
						a.download = filename
						a.href = e.target.result
						document.body.appendChild(a)
						a.click()
						document.body.removeChild(a)
					}
				})
		},
		downloadTemplate() {
			let vm = this
			this.axios
				.get('QuickReply/GetImportTemplate', { responseType: 'blob' })
				.then(function(res) {
					let filename = '快捷回复模板.xls'
					let blob = res.data
					let reader = new FileReader()
					reader.readAsDataURL(blob)
					reader.onload = e => {
						//创建a标签，插入到文档中并click，最后移除
						let a = document.createElement('a')
						a.download = filename
						a.href = e.target.result
						document.body.appendChild(a)
						a.click()
						document.body.removeChild(a)
					}
				})
		},
		importQuick() {
			let str = document.getElementsByClassName('el-upload__input')
			console.log(str)
			str[1].click()
		},
		uploadExcel(val) {
			if (val.result) {
				this.$message({ type: 'success', message: val.message })
				this.fetchQueryList()
			} else {
				this.$message({ type: 'error', message: val.message })
			}
			this.importLoading = false
		},
		uploadExcelErr(val) {},
		uploadExcelChange(val) {
			console.log(val)
			this.importLoading = true
		},
		updQuickGroup(id, name) {
			let vm = this
			this.axios
				.get('QuickReplyGroup/UpdGroupQuick', {
					params: { id: id, name: name }
				})
				.then(function({ data }) {
					if (data.result) {
						vm.$message({ type: 'success', message: '成功' })
					}
				})
		},
		changeNode(r, node, data) {
			let vm = this
			if (r.target.value != '') {
				data.label = r.target.value
				vm.quickGroup = r.target.value
				vm.treeData = data
				vm.updQuickGroup(data.id, data.label)
			} else {
				data.label = vm.defaultLabel
			}
		},
		renderContent(h, { node, data, store }) {
			if (node.label == 'add') {
				return (
					<span class="custom-tree-node">
						<span>
							<input
								class="treeInput"
								v-model={data.label}
								style="width: 100px;"
								on-blur={r => this.changeNode(r, node, data)}
								placeholder="输入组名称"
							></input>
						</span>
						<span>
							<i
								class="el-icon-delete"
								on-click={() => this.deleteGroup(node, data)}
							></i>
						</span>
					</span>
				)
			} else if (data.id == 0) {
				return (
					<span class="custom-tree-node">
						<span>{node.label}</span>
						<span>
							<i
								class="el-icon-plus"
								on-click={() => this.append(data)}
							></i>
						</span>
					</span>
				)
			} else if (node.level > 2) {
				return (
					<span class="custom-tree-node">
						<span>{node.label}</span>
						<span>
							<i
								class="el-icon-edit"
								on-click={() => this.editGroupName(data)}
							></i>
							<i
								class="el-icon-delete"
								on-click={() => this.deleteGroup(node, data)}
							></i>
						</span>
					</span>
				)
			} else {
				return (
					<span class="custom-tree-node">
						<span>{node.label}</span>
						<span>
							<i
								class="el-icon-plus"
								on-click={() => this.append(data)}
							></i>
							<i
								class="el-icon-edit"
								on-click={() => this.editGroupName(data)}
							></i>
							<i
								class="el-icon-delete"
								on-click={() => this.deleteGroup(node, data)}
							></i>
						</span>
					</span>
				)
			}
		},
		async append(data) {
			let vm = this
			// debugger
			vm.treeData = data
			// vm.addGroupVisible = true
			await vm.AddQuickGroup(data)
			// let id = vm.groupId
		},
		editGroupName(data) {
			this.defaultLabel = data.label
			data.label = 'add'
		},
		getQuickGroups(typeid) {
			let vm = this
			vm.fetchLoding = true
			this.axios
				.get('QuickReplyGroup/getQuickTree', {
					params: { typeid: typeid }
				})
				.then(function({ data }) {
					if (data.result) {
						vm.quickTree = data.data
					}
					vm.fetchLoding = false
				})
		},
		NodeClisk(val) {
			this.QuickGroupSelected(val)
			this.quickReply.groupId = val.id
			this.$refs.tree.store.nodesMap[val.id].expanded = true
			val.unfold = true
		},
		addGroup(val, d) {
			let vm = this
			let name = vm.quickGroup
		},
		deleteGroup(node, data) {
			let vm = this
			if (data.children.length > 0) {
				this.$alert('请先删除子集', '提示', {
					confirmButtonText: '确定',
					callback: action => {}
				})
				return
			}
			this.axios
				.get('QuickReplyGroup/DeleteGroupQuick', {
					params: {
						quickId: data.id
					}
				})
				.then(function({ data }) {
					if (data.result) {
						vm.$message({ type: 'success', message: '删除成功' })

						const parent = node.parent
						const children = parent.data.children || parent.data
						const index = children.findIndex(d => d.id === data.id)
						children.splice(index, 1)
					} else {
						this.$alert(data.message, '提示', {
							confirmButtonText: '确定',
							callback: action => {}
						})
					}
				})
		},
		addProblem() {
			let id = this.quickRequest.groupId
			if (id < 1 || id == undefined) {
				this.$alert('请先选中分组', '提示', {
					confirmButtonText: '确定',
					callback: action => {}
				})
				return
			}
			this.problemVisible = true
		},
		encryptECB(plaintText) {
			var plaintText = plaintText;
			var options = {
				mode: CryptoJS.mode.ECB,
				padding: CryptoJS.pad.Pkcs7
			};
			var key = CryptoJS.enc.Utf8.parse("e0YDC3vNOWhtY7Qy"); //秘钥
			var encryptedData = CryptoJS.AES.encrypt(plaintText, key, options);
			var encryptedBase64Str = encryptedData.toString();
			return encryptedBase64Str;
		}
	}
}
</script>
<style scoped>
.treeInput {
	border: none;
}
 .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
	 color: #4d95fd;
	 font-weight: bold;
}
.warpper
	.el-tree--highlight-current
	/deep/
	.el-tree-node.is-checked
	> .el-tree-node__content {
	background-color: rgb(255, 255, 255);
	color: rgb(64, 158, 255);
}
.warpper
	.el-tree--highlight-current
	/deep/
	.el-tree-node.is-current
	> .el-tree-node__content {
	background-color: rgb(255, 255, 255);
	color: rgb(64, 158, 255);
}

.container {
	padding: 0 35px;
}
.title {
	font-size: 16px;
	font-weight: bold;
	padding: 30px 0 20px 0;
	border-bottom: 1px solid #ddd;
}
.flex {
	width: 980px;
	max-height: 315px;
	margin: 0 auto;
	display: -webkit-flex; /*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	padding-top: 20px;
	padding-bottom: 30px;
}
.option {
	margin-top: 20px;
	min-height: 40px;
	line-height: 40px;
}
.txt {
	display: inline-block;
	float: left;
	min-width: 120px;
	color: #999;
	font-size: 12px;
}
.content {
	float: left;
}
.content {
	font-size: 16px;
}
.points {
	font-size: 12px;
	color: #999;
	line-height: 50px;
}
.save {
	margin-top: 90px;
}
.preview {
	text-align: center;
}
.img_box {
	width: 270px;
	height: 270px;
	border: 1px solid #ddd;
	margin-top: 30px;
}
.img_box img {
	display: block;
	width: 100%;
}
.radio {
	padding-top: 10px;
	padding-bottom: 30px;
}
.switch {
	margin-top: 30px;
	padding-bottom: 30px;
}
/*快捷服务*/
.setting {
	height: 100%;
	overflow: auto;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
	position: relative;
	width: 100%;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
}
.flex-box {
	height: 100%;
	overflow: auto;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
	position: relative;
	width: 100%;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
}
.service {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	position: relative;
	height: 100%;
	overflow-x: hidden;
}
.tac {
	width: 250px;
}
.tabs {
	width: 100%;
	height: 100%;
}
.tab-option {
	padding: 30px;
}
.service .title {
	border: none;
	padding: 0;
	float: left;
}
.content-box {
	padding: 10px 0 10px 0;
	line-height: 40px;
}
.content-box .el-input-group {
	float: right;
	width: 320px;
	margin-right: 15px;
}
.add {
	float: right;
}
.import {
	float: right;
}
.export {
	float: right;
	margin-right: 10px;
}
.delete {
	float: right;
	margin-right: 10px;
}
.table_box {
	margin-top: 30px;
}
.el-icon-edit {
	margin-left: 20px;
	margin-right: 30px;
}
.pagination {
	text-align: right;
}
.el-pagination {
	text-align: right;
	margin-top: 50px;
	display: inline-block;
}
.label {
	float: left;
	width: 120px;
	text-align: right;
	margin-right: 20px;
}
.section {
	line-height: 50px;
	margin-top: 10px;
}
.input_box {
	float: left;
	width: 60%;
}
.input_box .input {
	width: 100%;
}
#emoji1 {
	position: absolute;
	background: #fff;
	width: 450px;
	height: 150px;
	border: 1px solid #ebeef5;
	padding: 12px;
	z-index: 2000;
	color: #606266;
	line-height: 1.4;
	text-align: justify;
	font-size: 14px;
	-webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	word-break: break-all;
	bottom: 45px;
}
#emoji1 .el-tabs__content span {
	width: 30px;
	height: 30px;
	cursor: pointer;
	display: inline-block;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	font-style: normal;
	font-size: 20px;
}
</style>



<style>
.el-textarea__inner {
	height: 100px;
	background-color: #fafafa;
}
.option .el-input__inner {
	background-color: transparent;
}
.el-radio {
	/* display: block; */
	margin-top: 15px;
}
.el-tabs {
	height: 100%;
	overflow: auto;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
	position: relative;
	width: 100%;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
}
.el-tabs__content {
	height: 100%;
	overflow: auto;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
	position: relative;
	width: 100%;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
}
.el-tab-pane {
	height: 100%;
	overflow: auto;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
	position: relative;
	width: 100%;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
}
.el-col {
	height: 100%;
	border-right: 1px solid #ddd;
}
.el-menu {
	border-right: none;
}
.el-menu-item.is-active {
	background-color: #f2f3f5;
}
.el-tabs__nav-scroll {
	margin: 0 40px;
	overflow: hidden;
}
</style>

 
<style >
.custom-tree-node {
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 12px;
	padding-right: 8px;
}
.custom-tree-node i {
	margin-right: 5px;
}
</style>
 


// WEBPACK FOOTER //
// src/components/customer/setting/settings.vue